import { useRef, useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SelectPicker, Loader } from 'rsuite';

const BranchSearchPicker = ({
  data,
  name,
  value,
  onChange,
  className,
  request,
  count,
  onSearch = () => {},
  loading = false,
  width = '224px',
  cleanable = true
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const pickerRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the clicked element is the search box
      const isSearchBox = event.target.closest('.rs-search-box');

      if (
        open &&
        ref.current &&
        !ref.current.contains(event.target) &&
        (!menuRef.current || !menuRef.current.contains(event.target)) &&
        !isSearchBox // Don't close if clicking on search box
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', handleClickOutside, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleClickOutside, true);
    };
  }, [open]);

  const customRenderMenuItem = (value, obj, menu) => {
    return (
      <div
        key={obj?.id}
        className="branch-search-picker-item"
        style={width === '224px' ? { width: '200px' } : { width: '96%' }}
        onClick={(e) => {
          menu.props.onSelect(obj?.id, obj, e);
          setOpen(false);
        }}
      >
        <div>
          <div
            className="branch-search-picker-label"
            style={{ fontWeight: 'normal' }}
          >
            {obj.resellerName}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div ref={ref} className="relative">
      <SelectPicker
        container={() => ref.current}
        // loading={loading}
        open={open}
        ref={pickerRef}
        cleanable={cleanable}
        data={data || []}
        searchable={true}
        size="xs"
        name={name}
        value={value}
        onChange={(value) => {
          onChange(value);
          setOpen(false);
        }}
        style={{
          width: width,
          border: className ? '1px solid #Db2228' : '',
          borderRadius: className ? '12px' : ''
        }}
        placeholder="Select"
        onClick={() => setOpen(!open)}
        onSearch={onSearch}
        className="branch-search-picker"
        renderMenu={(menu) => (
          <div
            ref={menuRef}
            onMouseDown={(e) => e.preventDefault()}
            onScroll={(e) => e.stopPropagation()}
          >
            <InfiniteScroll
              dataLength={data?.length}
              next={request}
              hasMore={count !== data?.length}
              loader={
                loading && (
                  <h4 className="branch-search-picker-loader">
                    <Loader size="xs" speed="fast" />
                  </h4>
                )
              }
              height={menu?.props?.data?.length ? 252 : 52}
              scrollableTarget="scrollableDiv"
              className="branch-search-picker-scroll-container"
            >
              {menu?.props?.data?.length ? (
                menu?.props?.data?.map((item, index) =>
                  customRenderMenuItem(item.label, item, menu)
                )
              ) : (
                <div
                  className="branch-search-picker-no-data"
                  style={{ paddingTop: '15px' }}
                >
                  No data found
                </div>
              )}
            </InfiniteScroll>
          </div>
        )}
      />
    </div>
  );
};

export default BranchSearchPicker;
